import { useAuth0 } from "@auth0/auth0-react"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/logout")({
  component: RouteComponent,
})

function RouteComponent() {
  const { logout } = useAuth0()

  void logout({ logoutParams: { returnTo: window.location.origin } })

  return <div />
}
